module.exports = "/_next/static/images/cart-e902713ed034fae998f0327c2a3e8645.png";